export {
  DEFAULT_SLIDE_TEXT_SIZE,
  getSlideTextSizeCSSVariables,
  SLIDE_TEXT_SIZES,
  slideTextSizeLabel,
  type SlideTextSize,
} from "#slide-text-sizes";
